import React from 'react';
import { ReactComponent as CloseIcon } from 'Assets/svg/close-material.svg';
import { ReactComponent as OpenSearchIcon } from 'Assets/svg/open-search.svg';
import { EMPTY_FUNCTION } from 'Utils/constants';

const Input = props => {
  const {
    label,
    error = '',
    inputProps = {},
    className = '',
    showClearIcon = false,
    showSearchIcon = false,
    clearClick = EMPTY_FUNCTION,
    searchClick = EMPTY_FUNCTION,
  } = props;

  const { className: inputClassName = '', value } = inputProps;

  return (
    <div className={`input-wrapper ${className}`}>
      <label htmlFor={inputProps.id}>{label}</label>
      <input
        {...inputProps}
        className={`${inputClassName}${error !== '' ? ' error-border' : ''}`}
        onChange={e => inputProps.onChange(e.target.value)}
      />
      {showSearchIcon && (
        <OpenSearchIcon className="search-icon" onClick={searchClick} />
      )}
      {showClearIcon && value && (
        <CloseIcon className="clear-icon" onClick={clearClick} />
      )}
      {error !== '' && <div className="error">{error}</div>}
    </div>
  );
};

export default Input;
